// React component to display RouteInfo in a timeline

import React from 'react';
import TwTimeline from '../../../TwTimeline/TwTimeline';
import StopInfo from '../StopInfo/StopInfo';

import LoadUtils from '../../../../utils/loadUtils';
import Typography from '@mui/material/Typography';
import { StopStatus, Trip } from '../../../../redux/api/trips/trips.model';
import { Order } from '../../../../redux/api/orders/orders.model';
import { TwTripTooltipInfoProps } from '../../../TwLoadTooltipInfo/TwLoadTooltipInfo';
import useAuth from '../../../../providers/Auth/Auth.provider';
import { PROVIDER } from '../../../../providers/User/User.model';

export interface RouteInfoProps {
  /**
   * load
   * */
  load: Order;
  /**
   * boolean to show/hide the status update input
   */
  showStatusUpdateInput?: boolean;

  /**
   * boolean to show and restrict actions to customers
   */
  isCustomerLink: boolean;
  /**
   * boolean to show/hide the add signature action button
   */
  showAddSignatureAction?: boolean;
  /**
   * Public load token
   */
  publicLoadToken?: string;
  /**
   * callback called when signature is saved
   * */
  onSignatureSaved?: () => void;
  /**
   * boolean to show label for status, when true, the status input will be readonly
   */
  showStatusReadOnly?: boolean;
  /**
   * boolean to show check in and out times
   */
  showCheckInAndOutTimes: boolean;
  /**
   * Trips tooltip data
   */
  tripsTooltipDataArray?: TwTripTooltipInfoProps[];
}

const RouteInfo: React.FC<RouteInfoProps> = ({
  load,
  showStatusUpdateInput = true,
  showAddSignatureAction,
  isCustomerLink,
  publicLoadToken,
  showStatusReadOnly = false,
  tripsTooltipDataArray,
  showCheckInAndOutTimes,
  onSignatureSaved
}): JSX.Element => {
  const {
    data: { userData }
  } = useAuth();
  const enableLtl = userData?.tenant?.ltl_enabled || false;

  const orderRouteStops =
    load.stops && load.stops.length > 0 ? load.stops : load.full_route_stop_overview;

  return (
    <TwTimeline>
      {orderRouteStops?.map((stop, index) => {
        // Get the trip readable id related to the stop
        const ltlTripReadableId =
          enableLtl && stop.trip_readable_id ? stop.trip_readable_id : undefined;

        return (
          <>
            <StopInfo
              key={index}
              prevStop={orderRouteStops?.[index - 1]}
              stop={stop}
              nextStop={orderRouteStops?.[index + 1]}
              loadId={load.id}
              publicLoadToken={publicLoadToken}
              isCustomerLink={isCustomerLink}
              LTLTripReadableId={ltlTripReadableId}
              tripsTooltipDataArray={tripsTooltipDataArray}
              nextStopStatus={orderRouteStops ? orderRouteStops[index + 1]?.status : undefined}
              stopActionElement={
                showStatusUpdateInput ? (
                  <Typography
                    component={'span'}
                    sx={{
                      minWidth: '150px',
                      color: '#6B7280',
                      fontSize: '14px',
                      textAlign: 'right'
                    }}
                  >
                    {LoadUtils.getStopStatusReadableLabel(stop.status || StopStatus.notStarted)}
                  </Typography>
                ) : /*   ) : ( */

                undefined
              }
              showAddSignatureAction={showAddSignatureAction}
              onSignatureSaved={onSignatureSaved}
              showCheckInAndOutTimes={showCheckInAndOutTimes}
            />
          </>
        );
      })}
    </TwTimeline>
  );
};

export default RouteInfo;
